export default {
  id: 'risk-capital',
  title: 'Virtual Capital',
  content: `## Virtual Capital

TradeLab gives every user **₹10,00,000 of virtual capital** to trade with. This is fully simulated — it is not connected to any brokerage account, bank account, or real financial system.

---

## How Your Capital is Tracked

| Component | Description |
|---|---|
| Cash Balance | Uninvested money available for new trades |
| Invested Capital | Amount currently locked in open positions (at cost) |
| Unrealised P&L | Gain or loss on open positions at the current fetched price |
| Realised P&L | Locked-in profit or loss from trades you have already closed |
| Portfolio Value | Cash Balance + current market value of all open positions |

**Portfolio Value = Cash Balance + Invested Capital + Unrealised P&L**

---

## How Capital Is Deducted

When you place a **Market order**, capital is deducted immediately at the fill price × quantity.

When you place a **Limit order**, the required capital is **reserved** the moment the order goes OPEN. It is deducted from your spendable balance even before the order fills. If the order is cancelled, the reservation is released.

---

## Capital and Risk Discipline

Your Risk Profile sets a **Risk Per Trade %** and a **Max Daily Loss %**. These are not hard blocks — TradeLab does not prevent you from placing a trade that exceeds these limits. Instead, it flags the violation and scores it in your Behavior Analytics.

This mirrors real trading: a broker will not stop you from trading too large. Discipline must come from you.

---

## Daily Capital Behaviour

Your active capital does not reset to ₹10,00,000 every day. Gains and losses carry forward. Your portfolio value changes in real time as positions are marked to current prices.

A daily capital reset job runs at **9:00 AM IST** but this adjusts your available trading capacity based on your behaviour score — not a hard cash reset.

---

## What Happens if You Lose Too Much

There is no forced liquidation. If your portfolio value drops significantly, you can top up your virtual capital from:

**Profile → Virtual Money Top-up**

> There is no penalty for topping up. TradeLab is a learning tool — resetting capital and continuing to practice is the right move. The learning comes from the process, not from surviving a capital constraint.

---

## Capital Properties Reference

| Property | Value |
|---|---|
| Starting virtual capital | ₹10,00,000 |
| Currency | INR (virtual) |
| Leverage / Margin | Not supported — full-value trades only |
| Overnight positions | Supported (SWING / Delivery trades hold overnight) |
| Intraday auto-exit | 3:10 PM IST — all INTRADAY positions force-closed |
| Minimum order value | No hard minimum |
| Top-up | Available from Profile at any time |`,
};
